module.exports = __webpack_public_path__ + "img/img_title_kuaibaodian_normal.f7343fa8.png";